/** Shared Digital assistant options for Main Landing lead capture modal. */
export const LEAD_CAPTURE_AI_EMPLOYEE_OPTIONS = [
  { value: "roofing", label: "Roofing Company" },
  { value: "renovation", label: "Renovation Company" },
  { value: "real_estate", label: "Real Estate" },
];

export const LEAD_CAPTURE_VALID_BOT_TYPES = new Set(
  LEAD_CAPTURE_AI_EMPLOYEE_OPTIONS.map((o) => o.value)
);

/** Parse ?brain=, ?bot_type=, or ?lead_bot_type= query param for modal prefill. */
export function parseLeadCaptureBotType(raw) {
  const value = String(raw || "")
    .trim()
    .toLowerCase();
  return LEAD_CAPTURE_VALID_BOT_TYPES.has(value) ? value : null;
}
